import DonationProjectsList from "./DonationProjectsList";

export default function CriticalCases({ language = "en" }) {
  return <DonationProjectsList type="Case" language={language} />;
}
